export default {
  'test': '{attribute} - enter it!',
  'locale.ru': 'Russian',
  'locale.en': 'English',
  'locale.short.en': 'Eng',
  'locale.short.ru': 'Rus',
  // helmet
  'helmet.authorize': 'Sign In',
  'helmet.register': 'Sign Up',
  'helmet.password.restore': 'Restore password',
  'helmet.password.change': 'Change password',
  'helmet.auth': 'Sign In',
  'helmet.accessDenied': 'Access denied',
  'helmet.billing': 'Billing',
  'helmet.companyInfo': 'Company',
  'helmet.notices': 'Notifications',
  'helmet.personalInfo': 'Personal information',
  'helmet.analytics': 'Analytics',
  'helmet.bots': 'Bots',
  'helmet.collections': 'Collections',
  'helmet.collection': 'Collection - {name}',
  'helmet.collection.data': 'Collection - {name} - Data',
  'helmet.collection.indexes': 'Collection - {name} - Indexes',
  'helmet.collection.schema': 'Collection - {name} - Schema',
  'helmet.collection.settings': 'Collection - {name} - Settings',
  'helmet.collection.triggers': 'Collection - {name} - Triggers',
  'helmet.applications': 'Applications',
  'helmet.appServers': 'Application servers',
  'helmet.processes': 'Processes',
  'helmet.script.detail': 'Script - {name}',
  'helmet.script.notFound': 'Script not found!',
  'helmet.script.list': 'Scripts',
  'helmet.app.settings.community': 'Community',
  'helmet.app.settings.developers': 'Developers',
  'helmet.app.settings.push': 'PUSH settings',
  'helmet.app.settings.npm': 'NPM dependencies',
  'helmet.app.settings.plans': 'Pricing plan',
  'helmet.app.settings.security': 'Security',
  'helmet.app.settings.settings': 'Application settings',
  // notifications
  'notification.title.error': 'Error',
  'notification.title.success': 'Success',
  'notification.title.notice': 'Notice',
  'notification.title.warning': 'Warning!',
  // errors
  'error.code.403': 'Access denied.',
  'error.code.423': 'Read only.',
  'error.code.500': 'Internal error.',
  'error.code.601': 'Error validating the source data',
  'error.code.602': 'The certificate is not found.',
  'error.code.603': 'Invalid certificate.',
  'error.code.604': 'Invalid certificate type.',
  'error.code.605': 'Incorrect date of the certificate.',
  'error.code.606': 'Incorrect key of the client.',
  'error.code.607': 'Invalid access key.',
  'error.code.608': 'Invalid key type',
  'error.code.609': 'Invalid name of the application.',
  'error.code.610': 'Invalid ID.',
  'error.code.611': 'Limits of pricing plan.',
  'error.code.612': 'Incorrect date format.',
  'error.code.613': 'Wrong type of date.',
  'error.code.614': 'Incorrect parameters of payment.',
  'error.code.615': 'Need Indie pricing plan.',
  'error.code.616': 'Not enough money to pay.',
  'error.code.617': 'The payment system is not found.',
  'error.code.618': 'The payment is not done.',
  'error.code.619': 'The invoice is not found.',
  'error.code.620': 'The invoice is already paid for.',
  'error.code.621': 'Wrong amount of money.',
  'error.code.622': 'The payment system is not supported.',
  'error.code.623': 'The request Unknown order ID.',
  'error.code.624': 'Notification is not found.',
  'error.code.625': 'The application is not found.',
  'error.code.626': 'The application is read-only.',
  'error.code.627': 'Too short a username.',
  'error.code.628': 'Incorrect email.',
  'error.code.629': 'Too short password.',
  'error.code.630': 'Incorrect phone number.',
  'error.code.631': 'Incorrect INN.',
  'error.code.632': 'Incorrect PPC.',
  'error.code.633': 'Incorrect BIC.',
  'error.code.634': 'Incorrect BIN.',
  'error.code.635': 'Incorrect bank account.',
  'error.code.636': 'Incorrect correspondent account.',
  'error.code.637': 'User already exists.',
  'error.code.638': 'Missing authentication parameters.',
  'error.code.639': 'Incorrect authentication parameters.',
  'error.code.640': 'You have exceeded the number of attempts.',
  'error.code.641': 'Invalid captcha.',
  'error.code.642': 'User is not found.',
  'error.code.643': 'Invalid password reset code.',
  'error.code.644': 'The phone number is already in use.',
  'error.code.645': 'Pricing plan Indie ends before this option.',
  'error.code.646': 'Invalid value "page".',
  'error.code.647': 'Avatar is not found.',
  // currencies
  'currency.rubles': 'RUR',
  // links
  'link.documents': 'https://scorocode.github.io/scorocode-docs-en/',
  // ACL
  'acl.create': 'Creating',
  'acl.read': 'Reading',
  'acl.update': 'Update',
  'acl.remove': 'Delete',
  // collection
  'collection.error.nothingToSave': 'No changes to save',
  'collection.error.fieldsNotValid': 'Not all fields have valid values',
  'collection.title.editArray': 'Edit array',
  'collection.title.editObject': 'Edit object',
  // confirm
  'confirm.title.removeDocument': 'Are you sure that you want to remove this document?',
  'confirm.title.removeBot': 'Are you sure that you want to remove this bot?',
  'confirm.title.removeServer': 'Are you sure that you want to remove this server?',
  // tree
  'tree.emptyFolder': '(empty)',
  'tree.label.downloading': 'loading',
  // date
  'date.label.year': 'Year',
  'date.label.month': 'Month',
  'date.label.day': 'Day',
  // actions
  'action.download': 'Download',
  'action.further': 'Further',
  'action.apply': 'Apply',
  'action.refresh': 'Refresh',
  'action.approve': 'Validate',
  'action.remove': 'Delete',
  'action.cancel': 'Cancel',
  'action.upload': 'Download',
  'action.change': 'Change',
  'action.save': 'Save',
  'action.pay': 'Pay',
  'action.purchase': 'Purchase',
  'action.payWithBonuses': 'Pay with bonuses',
  'action.createScript': 'Create a script',
  'action.createFolder': 'Create a folder',
  'action.createServerCode': 'Create a server handler',
  'action.addCollection': 'Add a collection',
  'action.removeCollection': 'Remove the collection',
  'action.createIndex': 'Add index',
  'action.addDocument': 'Add document',
  'action.addField': 'Add field',
  'action.addFilter': 'Add filter',
  'action.removeFilter': 'Remove filter',
  'action.clearFilter': 'Reset filter',
  'action.filter': 'Filter',
  'action.saveChanges': 'Save Changes',
  'action.saveChangesAndRun': 'Save and Run',
  'action.removeApp': 'Remove application',
  'action.create': 'Create',
  'action.invite': 'To invite',
  'action.changeCaptcha': 'Change captcha',
  'action.logIn': 'Log in',
  'action.beginDevelopment': 'Start development',
  'action.restore': 'Recover',
  'action.send': 'Send',
  'action.changePassword': 'Change password',
  'action.cardPayment': 'Payment by card',
  'action.add': 'Add',
  'action.activate': 'Activate',
  'action.applyFilter': 'Apply filter',
  'action.sortByAsc': 'Ascending',
  'action.sortByDesc': 'Descending',
  'action.cancelChanges': 'Reset changes',
  'action.editDocument': 'Edit Document',
  'action.removeDocument': 'Remove the document',
  'action.select': 'Select',
  'action.deselect': 'Exclude',
  'action.addDependencies': 'Add dependencies',
  'action.removeDependencies': 'Delete dependencies',
  'action.selectDependency': 'Select dependency',
  'action.clear': 'Clear',
  'action.changeValue': 'Change value',
  'action.downloadFile': 'Download file {name}',
  'action.selectDate': 'Select date',
  'action.selectTime': 'Select time',
  'action.createBot': 'Create bot',
  'action.edit': 'Edit',
  'action.update': 'Update',
  'action.runScript': 'Run script',
  'action.filterOnlySelected': 'Only selected',
  'action.reset': 'Reset',
  'action.changeDependencies': 'Change dependencies',
  'action.uploadIosCertificate': 'Download certificate',
  'action.start': 'Start',
  'action.stop': 'Stop',
  // tables
  'table.header.name': 'Name',
  'table.header.personalName': 'Name',
  'table.header.date': 'Date',
  'table.header.sum': 'Sum',
  'table.header.status': 'Status',
  'table.header.email': 'Email',
  'table.header.actions': 'Actions',
  'table.header.optionName': 'Option name',
  'table.header.count': 'Amount',
  'table.header.buyDate': 'Date of purchase',
  'table.header.endDate': 'Expiration date',
  'table.header.months': 'Months',
  'table.header.discount': 'Discount',
  'table.header.total': 'Total',
  'table.header.price': 'Price',
  'table.header.pricePerMonth': 'Price / month',
  'table.header.pricePerYear': 'Price / year',
  'table.header.indexName': 'Index name',
  'table.header.index': 'Index',
  'table.header.fieldName': 'Field name',
  'table.header.sort': 'Sorting',
  'table.header.botName': 'Bot name',
  'table.header.telegramId': 'Telegram ID',
  'table.header.scriptId': 'Script ID',
  'table.label.status.active': 'Active',
  'table.label.status.inactive': 'Inactive',
  'table.label.status.started': 'Started',
  'table.label.status.stopped': 'Stopped',
  // nav
  'nav.label.language': 'Language',
  'nav.label.applications': 'Applications',
  'nav.label.documentation': 'Documentation',
  'nav.label.notices': 'Notices',
  'nav.label.support': 'Tech support',
  'nav.label.info': 'Information',
  'nav.label.organization': 'Company',
  'nav.label.balance': 'Billing',
  'nav.label.quit': 'Exit',
  'nav.label.data': 'Data',
  'nav.label.settings': 'Settings',
  'nav.label.schema': 'Schema',
  'nav.label.indexes': 'Indexes',
  'nav.label.triggers': 'Triggers',
  'nav.label.analytics': 'Analytics',
  'nav.label.serverCode': 'Server-side code',
  'nav.label.notifications': 'Newsletters',
  'nav.label.downloadSdk': 'Download SDK',
  'nav.label.code': 'Code',
  'nav.label.bots': 'Bots',
  'nav.label.roles': 'Roles',
  'nav.label.users': 'Users',
  'nav.label.gitter': 'Gitter',
  'nav.label.appServers': 'Application servers',
  // footer
  'footer.label.allRightsReserved': 'All rights reserved.',
  // forms
  'form.control.placeholder.typeUserName': 'Type user name',
  'form.control.placeholder.typeRoleName': 'Type role name',
  'form.control.label.wsNotify': 'WebSocket notifications',
  'form.control.label.operator': 'Operator',
  'form.control.label.value': 'Value',
  'form.control.label.name': 'Name',
  'form.control.label.path': 'Path',
  'form.control.label.description': 'Description',
  'form.control.label.email': 'Email',
  'form.control.label.personalName': 'Name',
  'form.control.placeholder.search': 'Search',
  'form.control.label.confirmAppRemove': 'To confirm, enter the name of the application',
  'form.control.error.confirmAppRemove': '^Specify the exact name of the application to be removed',
  'form.control.label.beginDate': 'The date of the beginning',
  'form.control.label.endDate': 'Expiration date',
  'form.control.label.type': 'Type',
  'form.control.label.appName': 'Application name',
  'form.control.label.appDescription': 'Application description',
  'form.control.label.image': 'Picture',
  'form.control.label.sessionTimeout': 'End session after {control} hours',
  'form.control.title.sessionTimeout': 'The duration of the user session',
  'form.control.title.verifyRegistration': 'Confirmation of registration',
  'form.control.label.sendEmailVerified': 'Sent an email confirmation to users to complete the registration',
  'form.control.label.emailTemplate': 'Letter template',
  'form.control.label.typeAppName': 'Enter the name of the application',
  'form.control.label.migrateFromParse': 'Migrating from Parse',
  'form.control.label.ParseLogin': 'Login Parse',
  'form.control.label.ParsePassword': 'Password Parse',
  'form.control.label.ParseApplicationId': 'Application ID',
  'form.control.placeholder.enterEmail': 'Enter the Email',
  'form.control.label.gcmSenderId': 'GCM Sender ID',
  'form.control.label.apiKey': 'API key',
  'form.control.placeholder.enterYourEmail': 'Enter your email',
  'form.control.placeholder.enterYourPassword': 'Enter your password',
  'form.control.placeholder.enterCaptchaCode': 'Enter the captcha code',
  'form.control.placeholder.enterYourName': 'Enter your name',
  'form.control.label.licenseAgreement': 'I accept the terms {link} and agree to receive email newsletter',
  'form.control.label.licenseAgreement.link': 'License Agreement',
  'form.control.label.subject': 'Subject',
  'form.control.label.messageText': 'Message Text',
  'form.control.label.newPassword': 'New password',
  'form.control.label.confirmPassword': 'Confirm password',
  'form.control.placeholder.sumPayment': 'Amount',
  'form.control.label.organizationName': 'Name',
  'form.control.label.urAddress': 'Legal Address',
  'form.control.label.factAddress': 'Actual Address',
  'form.control.label.phone': 'Phone number',
  'form.control.label.ogrn': 'PSRN',
  'form.control.label.inn': 'ITN',
  'form.control.label.kpp': 'IEC',
  'form.control.label.settlAcc': 'Bank Account',
  'form.control.label.corrAcc': 'Correspondent Account',
  'form.control.label.bankName': 'Name of the bank',
  'form.control.label.bik': 'BIC',
  'form.control.label.collectionName': 'Collection Name',
  'form.control.label.fieldName': 'Field Name',
  'form.control.label.dataType': 'Data Type',
  'form.control.label.collection': 'Collection',
  'form.control.label.indexName': 'Index Name',
  'form.control.label.indexFields': 'Index Fields',
  'form.control.label.isSystem': 'Is System',
  'form.option.selectItem': 'Select...',
  'form.control.label.useDocumentAcl': 'Use document\'s ACL',
  'form.acl.label.anonymousUsers': 'Anonymous Users',
  'form.control.title.unauthorizedAcl': 'ACL unauthorized users',
  'form.control.title.usersAcl': 'ACL Users',
  'form.control.title.rolesAcl': 'ACL Roles',
  'form.multiselect.emptyList': 'No Matches Found',
  'form.control.label.folderName': 'Folder Name',
  'form.control.label.scriptName': 'Script Name',
  'form.title.users': 'Users',
  'form.title.roles': 'Roles',
  'form.control.label.allowAnonymousLaunch': 'Allow anonymous launching',
  'form.title.scheduleStart': 'Scheduled start',
  'form.control.label.timerOn': 'Enable the timer',
  'form.control.label.jobStartAt': 'Start of action',
  'form.control.label.launch': 'Run',
  'form.control.label.withinDays': 'A day', // todo fix
  'form.control.label.days': 'Days',
  'form.control.label.hours': 'Hours',
  'form.control.label.minutes': 'Minutes',
  'form.control.label.selectDayOfWeek': 'The choice of the day of the week',
  'form.control.label.selectTime': 'The choice of the exact time',
  'form.control.label.selectMonth': 'The choice of the month',
  'form.control.label.selectDay': 'Select a day',
  'form.control.label.last': 'Last',
  'form.control.label.jobType.once': 'Once',
  'form.control.label.jobType.custom': 'Custom period',
  'form.control.label.jobType.daily': 'Daily',
  'form.control.label.jobType.monthly': 'Monthly',
  'form.control.label.day.monday': 'Monday',
  'form.control.label.day.tuesday': 'Tuesday',
  'form.control.label.day.wednesday': 'Wednesday',
  'form.control.label.day.thursday': 'Thursday',
  'form.control.label.day.friday': 'Friday',
  'form.control.label.day.saturday': 'Saturday',
  'form.control.label.day.sunday': 'Sunday',
  'form.control.label.month.january': 'January',
  'form.control.label.month.february': 'February',
  'form.control.label.month.march': 'March',
  'form.control.label.month.april': 'April',
  'form.control.label.month.may': 'May',
  'form.control.label.month.june': 'June',
  'form.control.label.month.july': 'July',
  'form.control.label.month.august': 'August',
  'form.control.label.month.september': 'September',
  'form.control.label.month.october': 'October',
  'form.control.label.month.november': 'November',
  'form.control.label.month.december': 'December',
  'form.option.selectField': 'Choose field ...',
  'form.option.selectOperator': 'Select the operator ...',
  'form.option.notSet': 'Not specified',
  'form.control.label.botName': 'Bot name',
  'form.control.label.botId': 'Bot identifier',
  'form.control.label.scriptId': 'Script ID',
  'form.control.label.isBotActive': 'Active',
  'form.control.placeholder.log': 'Log',
  'form.validate.presence': '* This field is required',
  'form.control.label.allowAll': 'Allow all',
  'form.control.label.autoRun': 'Autorun',
  'form.control.label.isRunning': 'Server is running',
  'form.validate.numericality.notValid': 'Enter the number',
  'form.validate.numericality.notInteger': 'Specify the number of decimal',
  'form.validate.numericality.notOdd': 'Enter an odd number',
  'form.validate.numericality.notEven': 'Enter an even number',
  'form.validate.numericality.notEqualTo': 'The value must be equal to {count}',
  'form.validate.numericality.notDivisibleBy': 'The value is not divisible by {count}',
  'form.validate.numericality.notGreaterThan': 'The value must be greater than {count}',
  'form.validate.numericality.notGreaterThanOrEqualTo': 'The value must be greater than or equal to {count}',
  'form.validate.numericality.notLessThan': 'The value must be less than {count}',
  'form.validate.numericality.notLessThanOrEqualTo': 'The value must be less than or equal to {count}',
  'form.validate.length.minimum': 'Specify the minimum {count, plural, one {one character} other {# characters}}',
  'form.validate.email': 'Please enter a valid Email',
  'form.validate.image': 'Uploaded file is not an image',
  'form.validate.ace': 'This field does not have the correct {format} format',
  'form.validate.json': 'This field does not have the correct JSON format',
  'form.validate.agreeLicense': 'Accept the license agreement',
  'form.validate.inclusion': '%{value} is not included in the list of valid values',
  'form.validate.isArrayJson': 'Json object should be of type "Array"',
  'form.validate.isObjectJson': 'Json object should be of type "Object"',
  'form.validate.isDateObject': 'The field has an invalid date format',
  'form.validate.presenceYourEmail': 'Enter your e-mail',
  'form.validate.presenceYourPassword': 'Enter your password',
  'form.validate.presenceYourConfirmPassword': 'Enter password confirmation',
  'form.validate.presenceYourName': 'Enter your name',
  'form.validate.presenceCaptcha': 'Enter the captcha',
  'form.validate.passwordNotConfirmed': 'Password does not match',
  // modals
  'modal.title.supportRequest': 'Tech support request',
  'modal.title.createBot': 'New bot',
  'modal.title.updateBot': 'Update bot',
  'modal.title.createAppServer': 'Create application server',
  'modal.title.updateAppServer': 'Update application server',
  // messages
  'message.pageNotFound': 'Page not found!',
  'message.messageSend': 'Message sent',
  'message.accountCreated': 'Account is created, look for details in the e-mail',
  'message.restorePasswordSuccess': 'You will be sent an email providing instructions to reset your password.',
  'message.dataChanged': 'Data changed',
  'message.dataSaved': 'Data saved',
  'message.settingsChanged': 'Settings have been changed',
  'message.passwordChanged': 'Password changed',
  'message.noticeRemoved': 'Notification removed',
  'message.noticeApproved': 'The notification is confirmed',
  'message.appCreated': 'The application is built',
  'message.appRemoved': 'Application "{name}" deleted',
  'message.certificateLoaded': 'Certificate loaded',
  'message.developerRemoved': 'Developer deleted',
  'message.developerInviteSend': 'The user sent a letter with the request',
  'message.paymentComplete': 'Payment is done',
  'message.planFreeUpgradeAlert': 'For purchasing additional options you must be on the Indie pricing plan',
  'message.appAclSettingsSaved': 'The ACL settings have been saved',
  'message.appKeyGenerated': 'A new {key} key has been generated',
  'message.serverCodeCreated': 'Server-side code "{name}" is created',
  'message.serverCodeRemoved': 'Server handler deleted',
  'message.folderCreated': 'Folder created',
  'message.folderRemoved': 'Folder deleted',
  'message.serverCodeSaved': 'Code changed',
  'message.collectionCreated': 'Collection "{name}" has been created',
  'message.collectionRemoved': 'Collection deleted',
  'message.triggerSaved': 'Trigger refreshed',
  'message.indexRemoved': 'Index removed',
  'message.indexCreated': 'Index added',
  'message.documentCreated': 'Document created',
  'message.documentRemoved': 'Document deleted',
  'message.documentUpdated': 'Document updated',
  'message.documentsRemoved': '{count, plural, one {Document deleted} other {# documents deleted}}',
  'message.collectionFieldRemoved': 'Field "{name}" is removed from the collection',
  'message.collectionFieldCreated': 'Field "{name}" added',
  'message.botCreated': 'Bot created',
  'message.botRemoved': 'Bot deleted',
  'message.botUpdated': 'Bot updated',
  // auth
  'auth.label.register' : 'Check in',
  'auth.label.forgetPassword' : ' Do you forgot password?',
  'auth.label.logIntoAccount' : '{logIn}, if you have an account.',
  'auth.label.logIn' : 'Log in',
  'auth.label.logInto' : 'Sign in',
  // profile index
  'profile.index.label.notices': 'Notifications',
  'profile.index.label.info': 'Personal information',
  'profile.index.label.changePassword': 'Change password',
  'profile.index.label.organization': 'Company',
  'profile.index.label.balance': 'Billing',
  // profile notices
  'profile.notices.title.notices': 'Notifications',
  // profile balance
  'profile.balance.title.balance' : 'Billing',
  'profile.balance.title.detail' : 'Payments',
  'profile.balance.label.balance' : 'Current billing',
  'profile.balance.label.bonuses' : 'Bonuses',
  'profile.balance.status.completed' : 'Done',
  'profile.balance.status.notCompleted' : 'Not done',
  'profile.balance.label.pay_indie': 'Indie pricing plan',
  'profile.balance.label.pay_developers': 'Unlimited number of developers in the application',
  'profile.balance.label.pay_rps': 'API requests per second',
  'profile.balance.label.pay_ws': 'Websocket connections',
  'profile.balance.label.pay_store': 'Cloud storage',
  'profile.balance.label.pay_scriptTimeout': 'Server-side code processing time',
  'profile.balance.label.pay_push': 'PUSH-notifications',
  // profile info
  'profile.info.title.personalInfo': 'Personal information',
  // profile change password
  'profile.password.title.changePassword': 'Change password',
  // profile organization
  'profile.organization.title.organization': 'Company',
  // app list
  'app.list.title.applications': 'Applications',
  'app.list.label.createApp': 'Create new application',
  'app.list.label.newApp': 'New application',
  'app.list.label.nothingFound': 'Nothing Found',
  // app analytics
  'app.analytics.graph.notices.title': 'Notifications',
  'app.analytics.graph.storage.title': 'Data size',
  'app.analytics.graph.users.title' : 'Users',
  'app.analytics.graph.overall.title': 'The total number of requests',
  'app.analytics.graph.android.title': 'Android',
  'app.analytics.graph.ios.title': 'iOS',
  'app.analytics.graph.javascript.title': 'JavaScript',
  'app.analytics.graph.trigger.title': 'Triggers',
  'app.analytics.graph.winphone.title': 'WinPhone',
  // app settings
  'app.settings.nav.label.settings': 'Application settings',
  'app.settings.nav.label.plans': 'Pricing plan',
  'app.settings.nav.label.security': 'Security',
  'app.settings.nav.label.notification': 'Push settings',
  'app.settings.nav.label.developers': 'Developers',
  'app.settings.nav.label.auth': 'Community',
  'app.settings.nav.label.npm': 'NPM dependencies',
  'app.settings.confirmRemove.title': 'Are you sure you want to remove the application?',
  'app.settings.notification.title.iosPush': 'iOS PUSH', // todo,
  'app.settings.notification.title.androidPush': 'Android PUSH', // todo,
  'app.settings.developers.title.developers': 'Developers',
  'app.settings.info.title.info': 'Application settings',
  'app.settings.npm.title.npm': 'NPM dependencies',
  'app.settings.security.title.acl': 'ACL',
  'app.settings.security.title.appKeys': 'Application keys',
  'app.settings.security.title.clientKeys': 'Client keys',
  'app.settings.security.acl.label': 'Allow anonymous access to the data',
  'app.settings.security.confirm.generateKey': 'Do you really want to generate a new key?',
  'app.settings.billing.history.rps': '+ {count} for API requests per second',
  'app.settings.billing.history.store': '+ {count} GB of cloud storage',
  'app.settings.billing.history.push': '+ {count} PUSH-notifications',
  'app.settings.billing.history.ws': '+ {count} of websocket simultaneous connections',
  'app.settings.billing.history.scriptTimeout': '+ {count} seconds to run-time server code',
  'app.settings.billing.history.developers': 'Unlimited number of developers in the application',
  'app.settings.plans.title.plan': 'Pricing plan',
  'app.settings.plans.title.selectPlan': 'Select a pricing plan',
  'app.settings.plans.title.activeOptions': 'A list of current active options',
  'app.settings.plans.title.upgradePlan': 'Upgrade your pricing plan',
  'app.settings.plans.label.currentPlan': 'The current rate',
  'app.settings.plans.label.requestsPerSecond': 'RPS',
  'app.settings.plans.label.store': 'Storage',
  'app.settings.plans.label.push': 'Push Notifications',
  'app.settings.plans.label.ws': 'WebSocket - the number of simultaneous connections',
  'app.settings.plans.label.scriptTimeout': 'Server-side code execution time',
  'app.settings.plans.label.developersCount': 'Number of developers',
  'app.settings.plans.label.developers.unlimited': 'Not limited',
  'app.settings.plans.label.indieSale': 'Hi there! We have a promo offer - get 3 months of Indie plan for 990 ₽',
  'app.settings.plans.label.free': 'Free',
  'app.settings.plans.label.indie': 'Indie',
  'app.settings.plans.label.enterpriseS': 'Enterprise S',
  'app.settings.plans.label.enterpriseM': 'Enterprise M',
  'app.settings.plans.label.enterpriseL': 'Enterprise L',
  'app.settings.plans.tariff.free': 'FREE pricing plan',
  'app.settings.plans.tariff.indie': 'INDIE pricing plan',
  'app.settings.plans.tariff.enterpriseS': 'ENTERPRISE S pricing plan',
  'app.settings.plans.tariff.enterpriseM': 'ENTERPRISE M pricing plan',
  'app.settings.plans.tariff.enterpriseL': 'ENTERPRISE L pricing plan',
  'app.settings.plans.tariff.rps': '10 API requests per second',
  'app.settings.plans.tariff.store': '1 GB of cloud storage',
  'app.settings.plans.tariff.push': '100 000 PUSH-notifications',
  'app.settings.plans.tariff.ws': '+1 000 simultaneous connections WebSocket',
  'app.settings.plans.tariff.scriptTimeout': 'Server-side code execution time',
  'app.settings.plans.tariff.developers': 'Unlimited number of developers in the application',
  'app.settings.plans.label.Gb': 'Gb',
  'app.settings.plans.label.remains': 'remains',
  // payment confirm
  'app.settings.billing.pay.confirm.indie': 'Confirm purchase pricing plan INDIE on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.enterpriseS': 'Confirm purchase pricing plan ENTERPRISE S on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.enterpriseM': 'Confirm purchase pricing plan ENTERPRISE M on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.enterpriseL': 'Confirm purchase pricing plan ENTERPRISE L on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.rps': 'Confirm purchase {count, plural, one {# query} other {# queries}} to the API in the second on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.store': 'Confirm purchase {count} GB of cloud storage on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.push': 'Confirm purchase {count, plural, one {# PUSH-notification} other {# PUSH-notifications}} to the API in the second on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.ws': 'Confirm purchase {count, plural, one {# simultaneous WebSocket connection} other {# simultaneous WebSocket connections}} to the API in the second on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.scriptTimeout': 'Confirm purchase {count, plural, one {# more second} other {# extra seconds}} at the time of execution of the server code {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.developers': 'Confirm purchase possibilities unlimited number of possible applications work on {months, plural, one {# month} other {# months}}',
  'app.settings.billing.pay.confirm.indieSale': 'Confirm purchase: "3 months of Indie plan (promo offer)"',
  // server code
  'app.serverCode.title.createServerCode': 'Create a server handler',
  'app.serverCode.title.newFolder': 'New folder',
  'app.serverCode.confirm.removeFolder': 'Do you really want to delete the folder?',
  'app.serverCode.confirm.removeServerCode': 'Are you sure you want to remove the server-handler?',
  // collections
  'app.collections.title.addDocument': 'Add document',
  'app.collections.title.updateDocument': 'Update document',
  'app.collections.title.addCollection': 'Add collection',
  'app.collections.nav.afterInsert': 'After Insert',
  'app.collections.nav.afterRemove': 'After Remove',
  'app.collections.nav.afterUpdate': 'After Update',
  'app.collections.nav.beforeInsert': 'Before Insert',
  'app.collections.nav.beforeRemove': 'Before Remove',
  'app.collections.nav.beforeUpdate': 'Before Update',
  'app.collections.title.createIndex': 'Add index',
  'app.collections.settings.confirmRemove.title': 'Are you sure you want to remove the collection?',
  'app.collections.settings.confirmRemove.index': 'Are you sure you want to remove collection index?',
  'app.collections.settings.confirmRemove.field': 'Are you sure you want to remove collection field?',
  // telegram bots
  'app.bots.title.telegramBots': 'Telegram bots',
  // documents
  'app.documents.confirm.removeSelectedDocuments': 'Are you sure you want to delete the selected documents?',
  'app.documents.title.addField': 'Add field',
  // instances
  'app.instances.title.appServers': 'Application servers',
  'app.instances.title.processes': 'Processes',
}


// WEBPACK FOOTER //
// ./src/messages/locale_en.js